import { render, staticRenderFns } from "./DataOverview.vue?vue&type=template&id=cf38b248&scoped=true&"
import script from "./DataOverview.vue?vue&type=script&lang=js&"
export * from "./DataOverview.vue?vue&type=script&lang=js&"
import style0 from "./DataOverview.vue?vue&type=style&index=0&id=cf38b248&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf38b248",
  null
  
)

export default component.exports